




















































































































































































































































































































import { Planning, PlanningCreateModel } from "@/api/models/planning/planning";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import {
  BButton,
  BModal,
  BTableSimple,
  BThead,
  BTr,
  BTh,
  BTbody,
  BTd,
  BAlert,
  BFormTextarea,
  BFormInput,
  BFormSelect,
  VBTooltip,
  BFormGroup,
} from "bootstrap-vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { DetailsUtilisateur } from "@/api/models/utilisateurs/utilisateur";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Site } from "@/api/models/sites/site";
import appSettings from "@/appSettings";

@Component({
  components: {
    BButton,
    BModal,
    BAlert,
    BTableSimple,
    BThead,
    BTr,
    BTh,
    BTbody,
    BTd,
    BFormTextarea,
    BFormInput,
    BFormGroup,
    BFormSelect,
    SearchableVueSelect,
    ValidationObserver,
    ValidationProvider,
  },
  directives: {
    'b-tooltip': VBTooltip
  }
})
export default class CreatePlanning extends Vue {
  @Prop({ required: true }) open!: Boolean;
  @Prop({ required: true }) type!: string;

  selectedDay: string = "";
  displayMessage: boolean = false;

  userSelected: any = null;
  listUser: any[] = [];
  totalCountUser = 0;
  types: any = null;
  tenantName = appSettings.getTenantName().toLowerCase();

  listSites: Site[] = [];

  planning: PlanningCreateModel = {
    lunM: false,
    lunA: false,
    marM: false,
    marA: false,
    merM: false,
    merA: false,
    jeuM: false,
    jeuA: false,
    venM: false,
    venA: false,
    message: "",
    messageLunM: "",
    messageLunA: "",
    messageMarM: "",
    messageMarA: "",
    messageMerM: "",
    messageMerA: "",
    messageJeuM: "",
    messageJeuA: "",
    messageVenM: "",
    messageVenA: "",
    siteId: null,
  };

  async created(params: any = null) {
    this.types = [this.type, this.type + ".EXT"];
    await this.loadUtilisateurs(params);
    await this.loadListSite();
  }

  async loadUtilisateurs(params: any) {
    await this.$http.myressif.utilisateurs
      .paginatedList(
        params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.search ?? "",
        false,
        "Nom",
        false,
        this.types
      )
      .then((res: any) => {
        this.listUser = res.items.map(
          (x: DetailsUtilisateur) =>
            <DetailsUtilisateur>{
              ...x,
              completeLabel: `${x.nom} ${x.prenom}`,
            }
        );
        this.totalCountUser = res.totalCount;
      });
  }

  closeModal() {
    this.$emit("close");
  }

  cellClick(selectedDay: string) {
    this.selectedDay = selectedDay;
    this.displayMessage = true;
  }

  async submit() {
    await this.$http.myressif.entreprises
      .addPlanning(
        this.$route.params.id,
        this.userSelected.id,
        this.type,
        this.planning
      )
      .then(
        async (response: any) => {
          successAlert.fire({
            title: "Ajout d'un planning",
            text: "Ajout effectuée avec succès",
          });
          this.$emit("planning-added");
          this.displayMessage = false;
          this.resetForm();
        },
        (error: any) => {
          if (error.response.data.errors) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error.message,
            });
          }
        }
      );
  }

  async loadListSite() {
    await this.$http.myressif.entreprises
      .getListSitesByEntrepriseId(this.$route.params.id)
      .then((response: Site[]) => {
        this.listSites = response;
      });
  }


  resetForm() {
    this.planning = {
      lunM: false,
      lunA: false,
      marM: false,
      marA: false,
      merM: false,
      merA: false,
      jeuM: false,
      jeuA: false,
      venM: false,
      venA: false,
      message: "",
      messageLunM: "",
      messageLunA: "",
      messageMarM: "",
      messageMarA: "",
      messageMerM: "",
      messageMerA: "",
      messageJeuM: "",
      messageJeuA: "",
      messageVenM: "",
      messageVenA: "",
    };
    this.userSelected = null;
  }
}
